import '../styles/ui.css';

export default function ListToolbar({
  title,
  subtitle,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filters = [],
  actions = null
}) {
  return (
    <div className="ui-toolbar">
      <div className="ui-toolbar__left">
        {title && <h1 className="ui-title">{title}</h1>}
        {subtitle && <p className="ui-subtitle">{subtitle}</p>}
      </div>
      <div className="ui-toolbar__right">
        {searchValue !== undefined && (
          <input
            className="ui-input"
            type="search"
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder={searchPlaceholder}
          />
        )}
        {filters}
        {actions}
      </div>
    </div>
  );
}
